/**
 * FRONT-1214: the guided tour's phase signal — the URL, on EVERY build.
 *
 * This is deliberately the ONLY reader of the `tour` search param, shared
 * by `routes/onboard.tsx` (phase derivation) and `layouts/auth-layout.tsx`
 * (card suppression) so the two can never disagree. It must never consult
 * `import.meta.env.DEV` or any other build-time flag: the original
 * FRONT-1014 wiring restored the tour from the URL only on dev builds, so
 * on the deployed environment the remount caused by AuthLayout's
 * card→fullscreen branch switch dropped the tour and stranded users on a
 * fullscreen wizard (BUG-060). Deliberate consequence: `/onboard?tour=1`
 * shows the (read-only, own-data) tour on deployed environments too.
 */
export function isTourPhaseSearch(search: string): boolean {
  return new URLSearchParams(search).get('tour') === '1';
}
